import styled from "styled-components";

export const Dot = styled.div<{ color: string; size?: number }>`
  background-color: ${props => props.color};
  width: ${props => props.size || 8}px;
  height: ${props => props.size || 8}px;
  border-radius: ${props => (props.size ? props.size / 2 : 4)}px;
  display: inline-block;
`;
